<template>
  <div>
    <p class="text-2xl">
      RCS
    </p>
    <v-card>
      <v-form autocomplete="off">
        <validation-observer ref="observer">
          <div class="px-2">
            <v-card-text class="pt-5">
              <v-row class="pt-2">
                <v-col>
                  <v-row>
                    <!-- Primeira linha: Nome da Campanha, Fornecedor e Agendamento -->
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Nome da Campanha"
                        rules="required"
                        vid="name"
                      >
                        <v-text-field
                          v-model="name"
                          :error-messages="errors"
                          :hide-details="errors.length === 0"
                          label="Nome da Campanha"
                          outlined
                          dense
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Agente"
                        rules="required"
                        vid="supplier"
                      >
                        <v-select
                          v-model="supplier"
                          :items="suppliers"
                          :error-messages="errors"
                          :hide-details="errors.length === 0"
                          outlined
                          dense
                          item-text="text"
                          item-value="value"
                          label="Agente"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Agendamento"
                        rules="required|max:160"
                        vid="sendDate"
                      >
                        <date
                          v-model="sendDate"
                          :error-messages="errors"
                          :hide-details="errors.length === 0"
                          :type="'datetime'"
                          dense
                          outlined
                          label="Agendamento"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <!-- Segunda linha: Tipo e Template -->
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                      lg="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Tipo"
                        rules="required"
                        vid="type"
                      >
                        <v-select
                          v-model="typeSms"
                          :items="types.filter( type => type.serviceId == 31 )"
                          :error-messages="errors"
                          :hide-details="errors.length === 0"
                          outlined
                          item-text="text"
                          item-value="value"
                          dense
                          label="Tipo"
                          @change="getSmsTemplates(typeSms)"
                        >
                          <template v-slot:item="{ item }">
                            <v-tooltip
                              right
                              open-on-hover
                              nudge-right="50"
                              max-width="320"
                              class="me-5"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  style="display: flex; justify-content: flex-end"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  {{ icons.mdiInformationOutline }}
                                </v-icon>
                              </template>
                              <span>{{ item.description
                              }}</span>
                            </v-tooltip>
                            <span class="mr-5">&nbsp; {{ item.text }}</span>
                          </template>
                        </v-select>
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Template"
                        rules="required"
                        vid="smsTemplateId"
                      >
                        <v-select
                          v-model="smsTemplateId"
                          :items="templates"
                          :error-messages="errors"
                          :hide-details="errors.length === 0"
                          outlined
                          dense
                          item-text="name"
                          item-value="id"
                          label="Template"
                          @change="setMessageCardPhone"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <!-- Terceira linha: Usar Fallback sozinho (md=4) e, se SIM, dois campos ao lado -->
                  <v-row>
                    <!-- <v-col
                      cols="12"
                      sm="12"
                      md="4"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Usar Fallback?"
                        rules="required"
                        vid="useFallback"
                      >
                        <v-select
                          v-model="useFallback"
                          :items="[{ value: true, text: 'Sim' }, { value: false, text: 'Não' }]"
                          :error-messages="errors"
                          :hide-details="errors.length === 0"
                          outlined
                          item-text="text"
                          dense
                          item-value="value"
                          label="Usar Fallback?"
                        />
                      </validation-provider>
                    </v-col>-->

                    <template v-if="useFallback">
                      <v-col
                        cols="12"
                        sm="12"
                        md="4"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          name="Nome da Campanha Fallback"
                          :rules="useFallback ? 'required|max:100' : ''"
                          vid="campaignNameFallback"
                        >
                          <v-text-field
                            v-model="campaignNameFallback"
                            :error-messages="errors"
                            :hide-details="errors.length === 0"
                            label="Nome da Campanha Fallback"
                            outlined
                            dense
                          />
                        </validation-provider>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        md="4"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          name="Template SMS Fallback"
                          :rules="useFallback ? 'required' : ''"
                          vid="smsTemplateFallbackId"
                        >
                          <v-select
                            v-model="smsTemplateFallbackId"
                            :items="templatesFallback"
                            :error-messages="errors"
                            :hide-details="errors.length === 0"
                            outlined
                            dense
                            item-text="name"
                            item-value="id"
                            label="Template SMS Fallback"
                          />
                        </validation-provider>
                      </v-col>
                    </template>
                  </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <v-card
                          class="mx-auto"
                          outlined
                        >
                          <v-card-text>
                            <v-textarea
                              v-model="phonesTextarea"
                              label="Telefones (DDD + número)"
                              outlined
                              dense
                              hide-details
                              placeholder="5511999999991
5511999999992
5511999999993
5511999999994"
                              @input="processFileContent(phonesTextarea)"
                            />

                            <v-divider class="my-3" />
                            <input
                              ref="refInputEl"
                              type="file"
                              accept=".txt, .csv"
                              :hidden="true"
                              @change="getFile"
                            />
                            <v-btn
                              class="me-3"
                              color="primary"
                              @click="$refs.refInputEl.click()"
                            >
                              <v-icon class="d-sm-none">
                                {{ icons.mdiCloudUploadOutline }}
                              </v-icon>
                              <span class="d-none d-sm-block">Subir Contatos</span>
                            </v-btn>
                            <v-btn
                              color="error"
                              outlined
                              @click="resetContacts"
                            >
                              Resetar
                            </v-btn>

                            <br />
                            <div class="mt-2">
                              Cole a lista de telefones ou selecione um arquivo <code>(.txt/.csv)</code>. <br>
                              <code v-if="selectedFile"><b>Arquivo selecionado:</b> {{ selectedFile }}</code>
                            </div>
                          </v-card-text>
                          <v-divider />
                          <v-card-actions>
                            <p class="mb-0">
                              Total de números no arquivo: <b class="primary--text">{{ totalPhones }}</b> <br />
                              Total de números duplicados a serem removidos: <b class="primary--text">{{ duplicatePhones
                              }}</b> <br />
                              Total geral de números: <b class="primary--text">{{ phones.length }}</b>
                            </p>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  md="3"
                  class="d-sm-flex justify-center position-relative"
                >
                  <div class="phone">
                    <div class="speaker"></div>
                    <div style="width: 425px; height: 771px">
                      <div class="center">
                        <div class="chat">
                          <div
                            id="chat"
                            class="messages"
                          >
                            <div
                              v-if="messageChat"
                              class="message parker"
                            >
                              <!-- RCS Template com imagem e botão -->
                              <div v-if="isRcsTemplate" class="rcs-message">
                                <!-- Preview para CAROUSEL -->
                                <div v-if="templateTypeRcs === 'CAROUSEL' && templateImages.length > 0" class="rcs-carousel-preview">
                                  <div class="rcs-carousel-container">
                                    <!-- Botão Anterior -->
                                    <v-btn
                                      v-if="templateImages.length > 1"
                                      icon
                                      x-small
                                      class="carousel-nav-btn carousel-prev"
                                      @click="previousCarouselImage"
                                    >
                                      <v-icon x-small>{{ icons.mdiChevronLeft }}</v-icon>
                                    </v-btn>
                                    
                                    <!-- Item do Carousel -->
                                    <div class="rcs-carousel-item">
                                      <div v-if="templateImages[carouselIndex]" class="rcs-banner">
                                        <img 
                                          :style="getCarouselImageStyle(carouselIndex)"
                                          :src="templateImages[carouselIndex]" 
                                          alt="RCS Carousel"
                                          class="banner-image"
                                        />
                                      </div>
                                      <div class="rcs-content">
                                        <h4 class="mb-1">{{ carouselTitles[carouselIndex] || templateName }}</h4>
                                        <p class="mb-2" v-html="messageChat"></p>
                                        <v-btn
                                          v-if="carouselActionUrls[carouselIndex]"
                                          color="primary"
                                          small
                                          outlined
                                          @click="openCarouselActionUrl(carouselIndex)"
                                        >
                                          {{ carouselButtonTitles[carouselIndex] || 'Ver mais' }}
                                        </v-btn>
                                      </div>
                                    </div>
                                    
                                    <!-- Botão Próximo -->
                                    <v-btn
                                      v-if="templateImages.length > 1"
                                      icon
                                      x-small
                                      class="carousel-nav-btn carousel-next"
                                      @click="nextCarouselImage"
                                    >
                                      <v-icon x-small>{{ icons.mdiChevronRight }}</v-icon>
                                    </v-btn>
                                  </div>
                                  
                                  <!-- Indicadores (dots) -->
                                  <div v-if="templateImages.length > 1" class="carousel-indicators">
                                    <span
                                      v-for="(img, index) in templateImages"
                                      :key="index"
                                      class="carousel-dot"
                                      :class="{ active: index === carouselIndex }"
                                      @click="carouselIndex = index"
                                    />
                                  </div>
                                </div>
                                
                                <!-- Preview para RICHCARD -->
                                <template v-else>
                                  <div v-if="templateImage" class="rcs-banner">
                                    <img 
                                      :style="getRichCardImageStyle()"
                                      :src="templateImage" 
                                      alt="RCS Banner"
                                      class="banner-image"
                                    />
                                  </div>
                                  <div class="rcs-content">
                                    <h4 class="mb-1">{{ templateTitle || templateName }}</h4>
                                    <p class="mb-2" v-html="messageChat"></p>
                                    <v-btn
                                      v-if="templateActionUrl"
                                      color="primary"
                                      small
                                      outlined
                                      @click="openActionUrl"
                                    >
                                      {{ templateButtonTitle || 'Ver mais' }}
                                    </v-btn>
                                  </div>
                                </template>
                              </div>
                              <!-- Template SMS normal -->
                              <span v-else v-html="messageChat" />
                            </div>
                          </div>
                          <div class="input">
                            <input
                              placeholder="Enviar mensagem..."
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>

          <!-- divider -->
          <v-divider></v-divider>

          <div class="pa-3 ps-7">
            <!-- action buttons -->
            <v-card-text>
              <v-btn
                color="primary"
                class="me-3 mt-5"
                @click="checkAccountConfirmation = true"
              >
                Salvar
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-5"
                @click="resetForm"
              >
                Limpar
              </v-btn>
            </v-card-text>
          </div>
        </validation-observer>
      </v-form>
    </v-card>

    <validation-observer
      ref="formCampaignSmsTemplate"
      autocomplete="off"
      tag="form"
      @keyup.enter="createSmsTemplate"
    >
      <dialog-form
        :status="dialogSmsTemplate"
        :is-update="false"
        :title="'SMS Template'"
        :width="1200"
        @action="createSmsTemplate"
        @close="dialogSmsTemplate = !dialogSmsTemplate"
      >
        <v-row>
          <v-col
            cols="6"
            sm="12"
            md="6"
          >
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Nome"
                  rules="required|max:100"
                  vid="form.name"
                >
                  <v-text-field
                    v-model="formSmsTemplate.name"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    label="Nome"
                    outlined
                    dense
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Tipo"
                  rules="required"
                  vid="type"
                >
                  <v-select
                    v-model="formSmsTemplate.type"
                    :items="smsTemplateTypes"
                    :error-messages="errors"
                    :hide-details="errors.length === 0"
                    outlined
                    item-text="text"
                    dense
                    item-value="value"
                    label="Tipo"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Mensagem"
                  rules="required"
                  vid="form.message"
                >
                  <v-textarea
                  
                    v-model="formSmsTemplate.message"
                    :counter-value="(value) => getMessageLenth(value)"
                    :error-messages="errors"
                    counter
                    label="Mensagem"
                    outlined
                  >
                  </v-textarea>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="d-sm-flex justify-center position-relative"
          >
            <div class="phone">
              <div class="speaker"></div>
              <div style="width: 425px; height: 771px">
                <div class="center">
                  <div class="chat">
                    <div
                      id="chat"
                      class="messages"
                    >
                      <div
                        v-if="formSmsTemplateChat"
                        class="message parker"
                      >
                        <span v-html="formSmsTemplateChat" />
                      </div>
                    </div>
                    <div class="input">
                      <input
                        placeholder="Enviar mensagem..."
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </dialog-form>
    </validation-observer>

    <confirm-account
      v-if="checkAccountConfirmation"
      @accountStatus="checkConfirmedAccount"
      @finish="store"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mdiCloudUploadOutline, mdiInformationOutline, mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import { ref } from '@vue/composition-api'
import {
  smsTypes,
  smsTemplateType,
  smsTemplateTypes,
  smsTemplate as smsTemplateEnum,
} from '@/utils/enum'
import {
  getTotalPhones,
  groupByArrayAndRemoveDuplicates,
  fileToCsv,
  getPhonesFromCsv,
} from '@/utils/filePhones'
import ConfirmAccount from '@/components/confirm-acount/index.vue'

export default {
  components: {
    ConfirmAccount,
  },
  setup() {
    const name = ref(null)
    const typeSms = ref(smsTypes[0].value)
    const sendDate = ref(null)
    const smsTemplateId = ref(null)
    const useFallback = ref(false)
    const message = ref('')
    const messageChat = ref('')
    const phones = ref([])
    const phonesTextarea = ref('')
    const duplicatePhones = ref(0)
    const totalPhones = ref(0)
    const templates = ref([])
    const templatesFallback = ref([])
    const selectedFile = ref(null)

    // Novos campos RCS
    const contentType = ref('RICHCARD')
    const supplier = ref(null)
    const campaignNameFallback = ref(null)
    let suppliers = []
    if (process.env.VUE_APP_EMPRESA_ID == 1) {
      suppliers = [
        { text: 'RCS Ligdata Basic', value: { broker_code: 'rcs_ligdata_basic', customer_code: 'rcs_ligdata', type: 'basic' }, type: 'basic' },
        { text: 'RCS Ligdata Single', value: { broker_code: 'rcs_ligdata_single', customer_code: 'rcs_ligdata', type: 'single' }, type: 'single' },
        { text: 'RCS Ligdata Conversational', value: { broker_code: 'rcs_ligdata_conversational', customer_code: 'rcs_ligdata', type: 'conversational' }, type: 'conversational' },
        { text: 'RCS PIXBET Single', value: { broker_code: 'rcs_pixbet_single', customer_code: 'PIXBET', type: 'single' }, type: 'single' },
      ]
    }
    
    if (process.env.VUE_APP_EMPRESA_ID == 2 || process.env.VUE_APP_EMPRESA_ID == 3 || process.env.VUE_APP_EMPRESA_ID == 4) {
      suppliers = [
        { text: 'RCS PIXBET Single', value: { broker_code: 'rcs_pixbet_single', customer_code: 'PIXBET' }, type: 'single' },
      ]
    }

    if (process.env.VUE_APP_EMPRESA_ID == 6) {
      suppliers = [
        { text: 'RCS Hands Digital Basic', value: { broker_code: 'HANDS DIGITAL', customer_code: 'PIXBET', type: 'basic' }, type: 'basic' },
        { text: 'RCS Hands Digital Single', value: { broker_code: 'HANDS DIGITAL', customer_code: 'PIXBET', type: 'single' }, type: 'single' },
      ]
    }
    const smsTemplateFallbackId = ref(null)
    
    const dialogSmsTemplate = ref(false)
    const formSmsTemplateChat = ref('')
    const formSmsTemplate = ref({
      name: ref(''),
      type: ref(null),
      message: ref(''),
    })

    const checkAccountConfirmation = ref(false)
    
    // Variáveis para RCS Template
    const isRcsTemplate = ref(false)
    const templateImage = ref('')
    const templateImages = ref([])
    const templateTypeRcs = ref('RICHCARD')
    const templateName = ref('')
    const templateTitle = ref('') // Título do card (titulo do template)
    const templateButtonTitle = ref('') // Título do botão
    const templateActionUrl = ref('')
    const carouselIndex = ref(0)
    const carouselMessages = ref([]) // Mensagens individuais de cada slide do carousel
    const carouselTitles = ref([]) // Títulos de cada slide do carousel
    const carouselButtonTitles = ref([]) // Títulos dos botões de cada slide do carousel
    const carouselActionUrls = ref([]) // URLs de ação de cada slide do carousel
    const templateImageSize = ref('MEDIUM') // Tamanho da imagem do template RICHCARD
    const carouselImageSizes = ref([]) // Tamanhos das imagens de cada slide do carousel
    
    // Tipos de conteúdo RCS
    const contentTypes = [
      { text: 'Rich Card', value: 'RICHCARD' },
      { text: 'Arquivo', value: 'FILE' },
      { text: 'Texto', value: 'TEXT' },
      { text: 'Carrossel', value: 'CAROUSEL' }
    ]

    console.log(smsTypes, 'AAAAAAAAAAA TYPE SMS')
    return {
      name,
      sendDate,
      smsTemplateId,
      typeSms,
      useFallback,
      message,
      messageChat,
      phones,
      phonesTextarea,
      duplicatePhones,
      totalPhones,
      templates,
      templatesFallback,
      dialogSmsTemplate,
      formSmsTemplateChat,
      formSmsTemplate,
      smsTemplateTypes,
      selectedFile,
      
      // Novos campos RCS
      contentType,
      contentTypes,
      
      // Variáveis para RCS Template
      isRcsTemplate,
      templateImage,
      templateImages,
      templateTypeRcs,
      templateName,
      templateTitle,
      templateButtonTitle,
      templateActionUrl,
      carouselIndex,
      carouselMessages,
      carouselTitles,
      carouselButtonTitles,
      carouselActionUrls,
      templateImageSize,
      carouselImageSizes,
      
      icons: {
        mdiCloudUploadOutline,
        mdiInformationOutline,
        mdiChevronLeft,
        mdiChevronRight,
      },
      types: smsTypes,
      checkAccountConfirmation,
      supplier,
      suppliers,
      campaignNameFallback,
      smsTemplateFallbackId,
    }
  },

  watch: {
    message(value) {
      const text = value.replace(/(?:\r\n|\r|\n)/g, '<br>')

      this.messageChat = this.$utils.replaceSpecialCharacters(text)
    },

    // Watch para quando mudar o fornecedor
    supplier(newValue, oldValue) {
      // Verificar se realmente mudou de fornecedor
      if (!newValue || (oldValue && oldValue.broker_code === newValue.broker_code &&
          oldValue.customer_code === newValue.customer_code &&
          oldValue.type === newValue.type)) {
        return;
      }

      // Limpar template selecionado
      this.smsTemplateId = null
      this.message = ''
      this.messageChat = ''
      this.isRcsTemplate = false
      this.templateImage = ''
      this.templateImages = []
      this.templateName = ''
      this.templateTitle = ''
      this.templateButtonTitle = ''
      this.templateActionUrl = ''
      this.carouselIndex = 0
      this.carouselMessages = []
      this.carouselTitles = []
      this.carouselButtonTitles = []
      this.carouselActionUrls = []
      this.templateImageSize = 'MEDIUM'
      this.carouselImageSizes = []

      // Recarregar templates filtrados pelo novo fornecedor
      if (newValue) {
        this.getSmsTemplates()
      } else {
        this.templates = []
      }
    },

    // eslint-disable-next-line func-names
    'formSmsTemplate.message': function (value) {
      const text = value.replace(/(?:\r\n|\r|\n)/g, '<br>')

      this.formSmsTemplateChat = this.$utils.replaceSpecialCharacters(text)
    },

    // Atualizar mensagem quando mudar o slide do carousel
    carouselIndex(newIndex) {
      if (this.templateTypeRcs === 'CAROUSEL' && this.carouselMessages.length > 0) {
        const message = this.carouselMessages[newIndex] || ''
        const text = message.replace(/(?:\r\n|\r|\n)/g, '<br>')
        this.messageChat = this.$utils.replaceSpecialCharacters(text)
        // Atualizar título do carousel também
        this.templateTitle = this.carouselTitles[newIndex] || this.templateName
        this.templateButtonTitle = this.carouselButtonTitles[newIndex] || ''
        this.templateActionUrl = this.carouselActionUrls[newIndex] || ''
      }
    },
  },

  async created() {
    this.sendDate = this.$day().format('DD/MM/YYYY HH:mm')
    await this.getSmsTemplates()
    await this.getSmsTemplatesFallback()
  },

  beforeDestroy() {
    // Limpar URLs de blob para evitar vazamentos de memória
    if (this.templateImage && this.templateImage.startsWith('blob:')) {
      URL.revokeObjectURL(this.templateImage)
    }
    this.templateImages.forEach(img => {
      if (img && img.startsWith('blob:')) {
        URL.revokeObjectURL(img)
      }
    })
  },

  methods: {
    ...mapActions('smsTemplates', {
      getTemplates: 'find',
      createTemplate: 'create',
      getTemplateById: 'findById',
    }),
    ...mapActions('controlFile', {
      getFileById: 'findById',
    }),
    ...mapActions('serviceRcs', [
      'create',
    ]),

    getMessageLenth(value) {
      return String(value.replace(/(?:\r\n|\r|\n)/g, '\n\n')).length
    },

    async openFormToCreate() {
      this.dialogSmsTemplate = true
      this.formSmsTemplateChat = ''
      this.formSmsTemplate = {
        name: null,
        type: [500].includes(this.typeSms) ? smsTemplateType.Bet : smsTemplateType.Default,
        message: '',
      }
    },

    resetContacts() {
      this.phones = []
      this.duplicatePhones = 0
      this.totalPhones = 0
      this.$refs.refInputEl.value = null
      this.selectedFile = null
    },

    resetForm() {
      this.name = null
      this.smsTemplateId = null
      this.sendDate = null
      this.typeSms = null
      this.message = ''
      this.messageChat = ''
      this.phones = []
      this.phonesTextarea = ''
      this.duplicatePhones = 0
      this.totalPhones = 0
      this.selectedFile = null
      
      // Resetar campos RCS
      this.contentType = 'RICHCARD'
      this.supplier = null
      this.campaignNameFallback = null
      this.smsTemplateFallbackId = null
      this.isRcsTemplate = false
      this.templateImage = ''
      this.templateImages = []
      this.templateName = ''
      this.templateTitle = ''
      this.templateButtonTitle = ''
      this.templateActionUrl = ''
      this.carouselIndex = 0
      this.carouselMessages = []
      this.carouselTitles = []
      this.carouselButtonTitles = []
      this.carouselActionUrls = []
      this.templateImageSize = 'MEDIUM'
      this.carouselImageSizes = []
    },

    async getSmsTemplates() {
      const smsType = smsTypes.find(t => t.value === this.typeSms)

      console.log(smsType, 'GET SMS TEMPLATES FUNCTION')
      
      // Montar filtro com dados do fornecedor selecionado
      const filter = {
        status: smsTemplateEnum.Approved,
        isRcs: 1,
      }
      
      // Adicionar filtro por fornecedor se selecionado
      if (this.supplier && this.supplier.broker_code) {
        filter.brokerCode = this.supplier.broker_code
        filter.customerCode = this.supplier.customer_code
        filter.supplierType = this.supplier.type
      }
      
      const templates = await this.getTemplates(filter)

      this.templates = templates.filter(t => t.serviceIds.includes(smsType.serviceId))

      console.log(templates,' AAAAAAAAAAAAAAAAAAA')
    },

    async getSmsTemplatesFallback() {
      const templates = await this.getTemplates({
        status: smsTemplateEnum.Approved,
        isRcs: 0,
      })
      // Filtrar apenas templates SMS Massivo (serviceId = 6)
      this.templatesFallback = templates.filter(t => t.serviceIds && t.serviceIds.includes(32))
    },

    async processFileContent(rows, type = 'text/plain') {
      let totalPhones = []
      let phones = []
      let duplicatePhones = 0

      if (type === 'text/csv') {
        totalPhones = fileToCsv(rows)
        phones = getPhonesFromCsv(totalPhones)
        duplicatePhones = totalPhones.length - phones.length
      } else {
        totalPhones = getTotalPhones(rows)
        phones = groupByArrayAndRemoveDuplicates(totalPhones)
        duplicatePhones = totalPhones.length - phones.length
      }

      this.phones = phones
      this.duplicatePhones = duplicatePhones
      this.totalPhones = totalPhones.length
    },

    async getFile(e) {
      if (!e.target.files || (e.target.files && !e.target.files[0])) {
        this.$notify(
          'Arquivo não importado.',
          'error',
        )

        return
      }

      const file = e.target.files[0]
      this.selectedFile = file.name

      if (!['text/plain', 'text/csv'].includes(file.type)) {
        this.$notify(
          'Selecione um arquivo (.txt/.csv).',
          'error',
        )

        return
      }

      const reader = new FileReader()
      reader.onload = e => this.processFileContent(e.target.result, file.type)
      reader.readAsText(file)
    },

    async setMessageCardPhone() {
      this.message = ''
      this.isRcsTemplate = false
      this.templateImage = ''
      this.templateImages = []
      this.templateTypeRcs = 'RICHCARD'
      this.templateName = ''
      this.templateTitle = ''
      this.templateButtonTitle = ''
      this.templateActionUrl = ''
      this.carouselIndex = 0
      this.carouselMessages = []
      this.carouselTitles = []
      this.carouselButtonTitles = []
      this.carouselActionUrls = []

      // Limpar URLs de blob anteriores
      if (this.templateImage && this.templateImage.startsWith('blob:')) {
        URL.revokeObjectURL(this.templateImage)
      }
      this.templateImages.forEach(img => {
        if (img && img.startsWith('blob:')) {
          URL.revokeObjectURL(img)
        }
      })

      if (this.smsTemplateId === -1) {
        await this.openFormToCreate()
        this.messageChat = ''
        this.formSmsTemplate.message = ''
        this.smsTemplateId = null
      } else {
        // Buscar template da lista para info básica
        let template = this.templates.find(t => t.id === this.smsTemplateId)

        if (!template) {
          this.$notify(
            'Conteúdo do template não encontrado.',
            'error',
          )

          return
        }

        // Se for RCS, buscar template completo via API para pegar todos os dados (titulo, buttonTitle, carouselItems, etc)
        if (template.isRcs === 1) {
          const fullTemplate = await this.getTemplateById(this.smsTemplateId)
          if (fullTemplate) {
            template = fullTemplate
          }
        }

        this.message = template.message
        
        // Verificar se é um template RCS
        if (template.isRcs === 1) {
          this.isRcsTemplate = true
          this.templateName = template.name
          this.templateTitle = template.titulo || template.name // Usar titulo se existir, senão usar name
          this.templateButtonTitle = template.buttonTitle || ''
          this.templateActionUrl = template.urlAction || ''
          this.templateTypeRcs = template.typeRcs || 'RICHCARD'
          this.templateImageSize = template.tamanho || 'MEDIUM' // Tamanho da imagem
          
          // Se for CAROUSEL, buscar os itens com mensagens individuais
          if (this.templateTypeRcs === 'CAROUSEL' && template.carouselItems && template.carouselItems.length > 0) {
            // Usar os carouselItems que já vêm do backend
            const carouselItems = template.carouselItems.sort((a, b) => (a.itemOrder || a.order || 0) - (b.itemOrder || b.order || 0))
            
            // Carregar imagens, mensagens, títulos, botões e tamanhos do carousel
            const imageUrls = []
            const messages = []
            const titles = []
            const buttonTitles = []
            const actionUrls = []
            const imageSizes = []
            
            for (const item of carouselItems) {
              try {
                const file = await this.getFileById(item.fileId)
                console.log(file, 'FILE CAROUSEL', item.fileId)
                
                if (file && file.data) {
                  const blob = new Blob([new Uint8Array(file.data)], { type: file.contentType || 'image/png' })
                  imageUrls.push(URL.createObjectURL(blob))
                  messages.push(item.message || '')
                  titles.push(item.titulo || '')
                  buttonTitles.push(item.buttonTitle || '')
                  actionUrls.push(item.urlAction || '')
                  imageSizes.push(item.tamanho || 'MEDIUM')
                }
              } catch (error) {
                console.error(`Erro ao carregar imagem do carousel ${item.fileId}:`, error)
              }
            }
            
            this.templateImages = imageUrls
            this.carouselMessages = messages
            this.carouselTitles = titles
            this.carouselButtonTitles = buttonTitles
            this.carouselActionUrls = actionUrls
            this.carouselImageSizes = imageSizes
            
            // Usar a mensagem, título e botão do primeiro slide como inicial
            if (messages.length > 0) {
              const text = messages[0].replace(/(?:\r\n|\r|\n)/g, '<br>')
              this.messageChat = this.$utils.replaceSpecialCharacters(text)
              this.templateTitle = titles[0] || this.templateName
              this.templateButtonTitle = buttonTitles[0] || ''
              this.templateActionUrl = actionUrls[0] || ''
            }
          } else if (template.imageFileId) {
            // Processar imagem(s) para RICHCARD ou fallback
            try {
              let imageFileIds = []
              if (typeof template.imageFileId === 'string') {
                try {
                  imageFileIds = JSON.parse(template.imageFileId)
                } catch {
                  imageFileIds = [Number(template.imageFileId)]
                }
              } else if (Array.isArray(template.imageFileId)) {
                imageFileIds = template.imageFileId
              } else {
                imageFileIds = [template.imageFileId]
              }

              const imageUrls = []
              for (const fileId of imageFileIds) {
                try {
                  const file = await this.getFileById(fileId)
                  console.log(file, 'FILE', fileId)
                  
                  if (file && file.data) {
                    const blob = new Blob([new Uint8Array(file.data)], { type: file.contentType || 'image/png' })
                    imageUrls.push(URL.createObjectURL(blob))
                  }
                } catch (error) {
                  console.error(`Erro ao carregar imagem ${fileId}:`, error)
                }
              }

              if (this.templateTypeRcs === 'RICHCARD' && imageUrls.length > 0) {
                this.templateImage = imageUrls[0]
                for (let i = 1; i < imageUrls.length; i++) {
                  URL.revokeObjectURL(imageUrls[i])
                }
              } else if (imageUrls.length > 0) {
                this.templateImage = imageUrls[0]
              }
            } catch (error) {
              console.error('Erro ao processar imagens:', error)
            }
          }
        }
      }
    },

    nextCarouselImage() {
      if (this.templateImages.length > 0) {
        this.carouselIndex = (this.carouselIndex + 1) % this.templateImages.length
      }
    },

    previousCarouselImage() {
      if (this.templateImages.length > 0) {
        this.carouselIndex = this.carouselIndex === 0 
          ? this.templateImages.length - 1 
          : this.carouselIndex - 1
      }
    },

    async checkConfirmedAccount(status) {
      if (status === true) {
        await this.store()
      }
    },

    async store() {
      this.checkAccountConfirmation = false

      if (await this.$refs.observer.validate()) {
        if (!this.phonesTextarea && this.phones.length === 0) {
          this.$notify(
            'Informe uma lista de números ou selecione um arquivo (.txt/.csv).',
            'error',
          )

          return
        }

        const status = await this.create({
          name: this.name,
          sendDate: this.$day(this.sendDate, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss'),
          typeSms: Number(this.typeSms),
          // hasInteraction: this.hasInteraction,
          useFallback: true,
          smsTemplateId: this.smsTemplateId,
          phones: this.phones,
          typeRcs: this.supplier?.type,
          brokerCode: this.supplier?.broker_code,
          customerCode: this.supplier?.customer_code,
          supplierType: this.supplier?.type,
          campaignNameFallback: this.useFallback ? this.campaignNameFallback : null,
          smsTemplateFallbackId: this.useFallback ? this.smsTemplateFallbackId : null,
          
        })

        if (status === 201) {
          this.$router.push('/report/service')
          this.resetForm()
          this.resetContacts()
        }
      }
    },

    openActionUrl() {
      if (this.templateActionUrl) {
        // Adicionar http:// se não tiver protocolo
        let url = this.templateActionUrl
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url
        }
        window.open(url, '_blank')
      }
    },

    openCarouselActionUrl(index) {
      const url = this.carouselActionUrls[index]
      if (url) {
        // Adicionar http:// se não tiver protocolo
        let actionUrl = url
        if (!actionUrl.startsWith('http://') && !actionUrl.startsWith('https://')) {
          actionUrl = 'https://' + actionUrl
        }
        window.open(actionUrl, '_blank')
      }
    },

    // Calcula as dimensões da imagem RICHCARD baseado no tamanho
    getRichCardImageStyle() {
      const size = this.templateImageSize || 'MEDIUM'
      const dimensions = this.getImageDimensions('RICHCARD', size)
      
      return {
        width: '100%',
        height: dimensions.height,
        objectFit: 'cover',
        display: 'block',
      }
    },

    // Calcula as dimensões da imagem do carousel baseado no tamanho
    getCarouselImageStyle(index) {
      const size = this.carouselImageSizes[index] || 'MEDIUM'
      const dimensions = this.getImageDimensions('CAROUSEL', size)
      
      return {
        width: '100%',
        height: dimensions.height,
        objectFit: 'cover',
        display: 'block',
      }
    },

    // Retorna as dimensões corretas baseado no tipo e tamanho
    getImageDimensions(type, size) {
      // RICHCARD: SHORT=1550x440px, MEDIUM=1550x660px, TALL=1550x1036px
      // CAROUSEL: SHORT=1340x640px, MEDIUM=1340x980px, TALL=1340x1530px
      
      // Proporções para o preview (largura fixa de ~300px no preview)
      const previewWidth = 300
      
      if (type === 'RICHCARD') {
        const aspectRatios = {
          SHORT: 440 / 1550,   // altura/largura
          MEDIUM: 660 / 1550,
          TALL: 1036 / 1550,
        }
        const aspectRatio = aspectRatios[size] || aspectRatios.MEDIUM
        return {
          width: `${previewWidth}px`,
          height: `${previewWidth * aspectRatio}px`,
        }
      } else if (type === 'CAROUSEL') {
        const aspectRatios = {
          SHORT: 640 / 1340,
          MEDIUM: 980 / 1340,
          TALL: 1530 / 1340,
        }
        const aspectRatio = aspectRatios[size] || aspectRatios.MEDIUM
        return {
          width: `${previewWidth}px`,
          height: `${previewWidth * aspectRatio}px`,
        }
      }
      
      // Fallback
      return {
        width: `${previewWidth}px`,
        height: `${previewWidth * 0.6}px`,
      }
    },

    async createSmsTemplate() {
      const body = {
        name: this.formSmsTemplate.name,
        type: this.formSmsTemplate.type,
        message: this.$utils.replaceSpecialCharacters(this.formSmsTemplate.message),
      }

      if (this.getMessageLenth(body.message) > 999) {
        this.$notify(
          'O campo mensagem pode conter até 999 caracteres.',
          'error',
        )

        return
      }

      if (await this.$refs.formCampaignSmsTemplate.validate()) {
        const { data } = await this.createTemplate(body)

        await this.getSmsTemplates()
        this.dialogSmsTemplate = false
        this.formSmsTemplateChat = ''
        this.smsTemplateId = data.id
        await this.setMessageCardPhone()
        this.formSmsTemplate = {
          name: null,
          type: null,
          message: '',
        }
      }
    },
  },
}
</script>

<style scoped>
.rcs-message {
  background: #006064;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 300px;
}

.rcs-banner {
  width: 100%;
  margin-bottom: 0;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  object-fit: cover;
  display: block;
}

.rcs-content {
  padding: 16px;
  border-radius: 0 0 8px 8px;
}

.rcs-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 8px 0;
}

.rcs-content p {
  font-size: 14px;
  color: #fff;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.rcs-carousel-preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
}

.rcs-carousel-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rcs-carousel-item {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  flex: 1;
}

.carousel-nav-btn {
  position: absolute;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5) !important;
  color: white !important;
  min-width: 28px !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 50%;
}

.carousel-nav-btn:hover {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.carousel-prev {
  left: 8px;
}

.carousel-next {
  right: 8px;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px;
}

.carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-dot:hover {
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.2);
}

.carousel-dot.active {
  background-color: rgba(255, 255, 255, 0.9);
  width: 24px;
  border-radius: 4px;
}
</style>

